import { createFileRoute } from '@tanstack/react-router';
import { ServiceCategoryForm } from '../../../features/service-categories/components/service-category-form';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/service-categories/new')({
  staticData: { breadcrumb: 'Новая' },
  component: NewServiceCategoryPage,
});

function NewServiceCategoryPage() {
  return (
    <div>
      <PageHeader title="Новая категория" />
      <ServiceCategoryForm mode="create" />
    </div>
  );
}
